import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';

export function Dialog({ ...props }: DialogPrimitive.Root.Props) {
  return <DialogPrimitive.Root data-slot="dialog" {...props} />;
}
